import React from 'react';
const LineColors = [
    ["#F8f8f8", "#f3f3f3"],
    ["#efefef", "#eaeaea"]
]
const height= "30px"
export default class ContractWindowCard extends React.Component {
    render() {
        let mainStyle = {
            display: "flex",
            maxHeight: height,
            width: "1330",
            fontSize: `${this.props.fontSize ?? 12}px`,
            fontWeight: this.props.fontWeight ?? "bold",
            textAlign: "center",
            verticalAlign: "middle",
            lineHeight: height
        }
        let colorColumnEven = {
            background: LineColors[this.props.index % 2][0],
            maxHeight: height
        }

        let colorColumnOdd = {
            background: LineColors[this.props.index % 2][1],
            maxHeight: height
        }

        return <div style={mainStyle}>
            <div style={{
                ...colorColumnEven,
                width: "60px"
            }}>
                {this.props.code || "–"}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.startDate || "–"}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "200px"
            }}>
                {this.props.orderType || "–"}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.locoType || "–"}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.brigades || "–"}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "210px"
            }}>
                {this.props.brigadePlace || "–"}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.price || "–"}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.from || "–"}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.to || "–"}
            </div>
            <div style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.seats || "–"}
            </div>
            <div style={{
                ...colorColumnEven,
                width: "110px"
            }}>
                {this.props.due || "–"}
            </div>
            <div className="contract-penalty" style={{
                ...colorColumnOdd,
                width: "110px"
            }}>
                {this.props.penalty || "–"}
            </div>
        </div>;
    }
}
